export default __webpack_public_path__ + "media/images/images/datatables/images/sort_asc-4bba59196d7ce26196967adefd7c5c3f.png";